import { useEffect } from 'react'

interface Props {
  type?: string
}

const AUDIO_ENGINE_KEY = 'audio-engine'

export const useDefineAudioEngine = ({ type }: Props): void => {
  useEffect(() => {
    if (!type || type === 'default') {
      localStorage.removeItem(AUDIO_ENGINE_KEY)
    } else {
      localStorage.setItem(AUDIO_ENGINE_KEY, type)
    }
  }, [type])
}
